<template>
  <Dropdown
    v-model="active"
    placement="bottom-start"
  >
    <button
      slot="activator"
      slot-scope="{ toggle, isOpen }"
      type="button"
      class="flex items-center text-white px-[10px] py-1 rounded-full bg-[#111224] text-xs whitespace-nowrap"
      @click="toggle(), trackButtonClickEvent()"
    >
      {{ selectedCategoryText }}
      <i
        :class="[
          'fa-regular ml-[10px] text-[10px]',
          isOpen ? 'fa-chevron-up' : 'fa-chevron-down',
        ]"
      />
    </button>
    <ul class="content bg-p5 w-48 rounded-md mt-3 py-[10px]">
      <li
        v-for="category in SearchCategories"
        :key="category.id"
      >
        <button
          class="text-primary-offwhite px-5 py-[10px] hover:bg-white hover:bg-opacity-5 w-full text-left"
          @click="selectCategory(category.id)"
        >
          {{ category.name }}
        </button>
      </li>
    </ul>
  </Dropdown>
</template>

<script>
import analyticsEvents from '@/utils/analyticsEvents';
import { eventTracker } from '@/utils/eventTracker';
import { SearchCategories } from '@/constants';
import Dropdown from './dropdown.vue';

export default {
  components: { Dropdown },
  props: {
    value: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      active: false,
    };
  },
  computed: {
    SearchCategories: () => SearchCategories,
    selectedCategoryText() {
      return SearchCategories.find(item => item.id === this.value)?.name || '';
    },
  },
  watch: {
    active(val) {
      this.$emit('open', val);
    },
  },
  methods: {
    selectCategory(category) {
      this.$emit('input', category);
      this.active = false;
      eventTracker(analyticsEvents.buttonClicked, {
        flow: 'search',
        click_source: 'navigation bar',
        section: 'search bar',
        button_name: category,
      });
    },
    trackButtonClickEvent() {
      eventTracker(analyticsEvents.buttonClicked, {
        flow: 'search',
        click_source: 'navigation bar',
        section: 'search bar',
        button_name: 'All Categories',
      });
    },
  },
};
</script>

<style scoped>
.content {
  box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.3);
}
.ml-\[10px\] {
  margin-left: 10px;
}
.text-\[10px\] {
  font-size: 10px;
}
.px-\[10px\] {
  padding-left: 10px;
  padding-right: 10px;
}
.py-\[10px\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.bg-\[\#111224\] {
  background-color: #111224;
}
</style>
